import React from 'react';
import { ShoppingCart } from 'lucide-react';
interface CtaButtonProps {
  text: string;
  className?: string;
  scrollTo?: string;
}
export function CtaButton({
  text,
  className = '',
  scrollTo
}: CtaButtonProps) {
  const cartUrl = 'https://lasrecetasdeana.com/cart/add?id=47506286477466&quantity=1&return_to=/checkout';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Si tiene scrollTo, hace scroll suave al elemento
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      return;
    }
    // Dispara evento AddToCart en UTMify pixel
    const win = window as any;
    if (win.pixelId && typeof win.utmify_pixel === 'function') {
      win.utmify_pixel('track', 'AddToCart');
    }
    // Forzar navegación (funciona dentro de iframes)
    try {
      window.top!.location.href = cartUrl;
    } catch {
      window.location.href = cartUrl;
    }
  };
  return <a href={scrollTo ? `#${scrollTo}` : cartUrl} onClick={handleClick} className={`
        group relative inline-flex items-center justify-center w-full sm:w-auto 
        px-8 py-4 text-lg md:text-xl font-bold text-white 
        bg-cta-600 rounded-xl overflow-hidden shadow-lg 
        transition-all duration-300 hover:scale-105 hover:shadow-xl hover:bg-cta-500
        animate-pulse-glow
        ${className}
      `} data-id="element-90">
      {/* Shimmer effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:animate-shimmer pointer-events-none" data-id="element-91" />

      <ShoppingCart className="w-6 h-6 mr-3" data-id="element-92" />
      <span data-id="element-93">{text}</span>
    </a>;
}